import React, { useState } from 'react';
import { LinkIcon, CheckCircleIcon, XIcon, PlusIcon, LockIcon, ShieldIcon, InfoIcon } from 'lucide-react';
export function OpenBankingConnect() {
  const [connecting, setConnecting] = useState<string | null>(null);
  const [connected, setConnected] = useState<string[]>([]);
  const banks = [{
    id: 'barclays',
    name: 'Barclays',
    logo: 'https://logo.clearbit.com/barclays.co.uk',
    color: '#00AEEF'
  }, {
    id: 'hsbc',
    name: 'HSBC',
    logo: 'https://logo.clearbit.com/hsbc.co.uk',
    color: '#DB0011'
  }, {
    id: 'lloyds',
    name: 'Lloyds Bank',
    logo: 'https://logo.clearbit.com/lloydsbank.com',
    color: '#006A4D'
  }, {
    id: 'natwest',
    name: 'NatWest',
    logo: 'https://logo.clearbit.com/natwest.com',
    color: '#4E2583'
  }, {
    id: 'santander',
    name: 'Santander',
    logo: 'https://logo.clearbit.com/santander.co.uk',
    color: '#EC0000'
  }, {
    id: 'monzo',
    name: 'Monzo',
    logo: 'https://logo.clearbit.com/monzo.com',
    color: '#FF4D56'
  }];
  const handleConnect = (bankId: string) => {
    setConnecting(bankId);
    // Simulate connection process
    setTimeout(() => {
      setConnected([...connected, bankId]);
      setConnecting(null);
    }, 2000);
  };
  const handleDisconnect = (bankId: string) => {
    setConnected(connected.filter(id => id !== bankId));
  };
  return <div className="space-y-6" data-id="element-532">
      <div className="flex items-center justify-between" data-id="element-533">
        <h1 className="text-2xl font-bold text-text-primary" data-id="element-534">Open Banking</h1>
        <div className="flex items-center bg-primary/10 text-primary text-sm px-3 py-1 rounded-full" data-id="element-535">
          <ShieldIcon className="w-4 h-4 mr-1.5" data-id="element-536" />
          <span data-id="element-537">Secure Connection</span>
        </div>
      </div>
      <div className="bg-white rounded-xl shadow-sm p-6 border border-gray-100" data-id="element-538">
        <div className="flex items-start space-x-3 mb-6" data-id="element-539">
          <InfoIcon className="w-5 h-5 text-primary mt-0.5" data-id="element-540" />
          <div data-id="element-541">
            <h2 className="text-lg font-medium text-text-primary" data-id="element-542">
              What is Open Banking?
            </h2>
            <p className="text-text-secondary mt-1" data-id="element-543">
              Open Banking allows you to securely connect your accounts from
              other banks to Cauri. This gives you a complete view of your
              finances in one place, with enhanced budgeting tools and insights.
            </p>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-544">
          <div className="flex items-center p-4 bg-gray-50 rounded-lg" data-id="element-545">
            <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center mr-3" data-id="element-546">
              <LockIcon className="w-5 h-5 text-primary" data-id="element-547" />
            </div>
            <div data-id="element-548">
              <p className="font-medium text-text-primary" data-id="element-549">Secure Access</p>
              <p className="text-sm text-text-secondary" data-id="element-550">
                Your data is encrypted and protected
              </p>
            </div>
          </div>
          <div className="flex items-center p-4 bg-gray-50 rounded-lg" data-id="element-551">
            <div className="w-10 h-10 rounded-full bg-secondary/10 flex items-center justify-center mr-3" data-id="element-552">
              <LinkIcon className="w-5 h-5 text-secondary" data-id="element-553" />
            </div>
            <div data-id="element-554">
              <p className="font-medium text-text-primary" data-id="element-555">Easy Connection</p>
              <p className="text-sm text-text-secondary" data-id="element-556">
                Link accounts in just a few clicks
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-white rounded-xl shadow-sm border border-gray-100" data-id="element-557">
        <div className="p-4 border-b border-gray-100" data-id="element-558">
          <h2 className="text-lg font-semibold text-text-primary" data-id="element-559">
            Connect Your Accounts
          </h2>
        </div>
        <div className="p-6 space-y-4" data-id="element-560">
          {banks.map(bank => {
          const isConnected = connected.includes(bank.id);
          const isConnecting = connecting === bank.id;
          return <div key={bank.id} className="flex items-center justify-between p-4 bg-gray-50 rounded-lg" data-id="element-561">
                <div className="flex items-center" data-id="element-562">
                  <div className="w-12 h-12 rounded-lg flex items-center justify-center bg-white p-2 mr-4 border border-gray-200" data-id="element-563">
                    <img src={bank.logo} alt={`${bank.name} logo`} className="max-w-full max-h-full" onError={e => {
                  e.currentTarget.src = `https://via.placeholder.com/40/${bank.color.replace('#', '')}?text=${bank.name[0]}`;
                }} data-id="element-564" />
                  </div>
                  <div data-id="element-565">
                    <p className="font-medium text-text-primary" data-id="element-566">{bank.name}</p>
                    <p className="text-xs text-text-secondary" data-id="element-567">
                      {isConnected ? 'Connected' : 'Not connected'}
                    </p>
                  </div>
                </div>
                {isConnecting ? <div className="flex items-center bg-primary/10 text-primary px-3 py-1.5 rounded-lg text-sm" data-id="element-568">
                    <div className="w-4 h-4 border-2 border-primary border-t-transparent rounded-full animate-spin mr-2" data-id="element-569"></div>
                    Connecting...
                  </div> : isConnected ? <div className="flex space-x-2" data-id="element-570">
                    <div className="flex items-center bg-green-100 text-green-700 px-3 py-1.5 rounded-lg text-sm" data-id="element-571">
                      <CheckCircleIcon className="w-4 h-4 mr-1" data-id="element-572" />
                      Connected
                    </div>
                    <button onClick={() => handleDisconnect(bank.id)} className="bg-gray-200 text-gray-700 px-3 py-1.5 rounded-lg text-sm hover:bg-gray-300" data-id="element-573">
                      <XIcon className="w-4 h-4" data-id="element-574" />
                    </button>
                  </div> : <button onClick={() => handleConnect(bank.id)} className="bg-primary text-white px-3 py-1.5 rounded-lg text-sm hover:bg-primary/90" data-id="element-575">
                    Connect
                  </button>}
              </div>;
        })}
          <button className="flex items-center justify-center w-full p-4 border border-dashed border-gray-300 rounded-lg text-primary hover:bg-primary/5" data-id="element-576">
            <PlusIcon className="w-5 h-5 mr-2" data-id="element-577" />
            <span data-id="element-578">Add Another Bank</span>
          </button>
        </div>
      </div>
    </div>;
}